export const ManagedIcon = ({ size = 12, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M5.245 1.115L3.025 1.955C2.45 2.17 1.98 2.85 1.98 3.46V7.175C1.98 7.765 2.37 8.54 2.845 8.895L4.695 10.3C5.4 10.83 6.56 10.83 7.265 10.3L9.115 8.895C9.59 8.54 9.98 7.765 9.98 7.175V3.46C9.98 2.845 9.51 2.165 8.935 1.95L6.715 1.115C6.31 0.96 5.645 0.96 5.245 1.115Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.52498 5.945L5.32498 6.745L7.47498 4.595"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
